let backendHost;
let reactAppUrl;
const hostname = window && window.location && window.location.hostname;
if (hostname === "localhost" && window.location.port === "3000") {
  backendHost = "https://damos.hf.uio.no";
  reactAppUrl = "/";
} else if (hostname === "localhost") {
  backendHost = "http://localhost";
  reactAppUrl = "/ny-damos/";
} else if (hostname === "dn.dmlf.hf.uio.no") {
  backendHost = "https://dn.hf.uio.no";
  reactAppUrl = "/ny-damos/";
} else if (hostname === "an.hf.uio.no") {
  backendHost = "https://an.hf.uio.no";
  reactAppUrl = "/ny-damos/";
} else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || "https://damos.hf.uio.no";
  reactAppUrl = "/";
}
export const API_ROOT = `${backendHost}`;
export const REACT_APP_URL = `${reactAppUrl}`;



// WEBPACK FOOTER //
// ./src/services/api-config.js